import { render, staticRenderFns } from "./ysyl.vue?vue&type=template&id=0223d63c&scoped=true&"
import script from "./ysyl.vue?vue&type=script&lang=js&"
export * from "./ysyl.vue?vue&type=script&lang=js&"
import style0 from "./ysyl.vue?vue&type=style&index=0&id=0223d63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0223d63c",
  null
  
)

export default component.exports